export default __webpack_public_path__ + "static/media/car-broken-error-meta.9d101704.png";